import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Table, Card } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/Opportunities.css";
import { ChevronLeft, ChevronRight } from "lucide-react";


const Opportunities = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) {
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="opportunities-section">
            <Container>
              <h2 className="opportunities-heading">Opportunities</h2>

                {/* <Card className="p-0 opportunities-card mt-3">
                    <Table bordered responsive className="opportunities-table">
                    <thead>
                        <tr>
                        <th>Job Title</th>
                        <th className="w-75">Job Description</th>
                        <th>Updated On</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Jobs in Bengaluru</td>
                            <td>Evolve Paediatric Therapy Services in Jayanagar Looks for Occupational Therapists. Both Bachelors and Master degree holders can apply. Attractive salary will be paid based on the Experience. Contact +919686548709 for further details.</td>
                            <td>2018-06-21</td>
                        </tr>
                        <tr>
                            <td>Jobs in Bengaluru</td>
                            <td>Evolve Paediatric Therapy Services in Jayanagar Looks for Occupational Therapists. Both Bachelors and Master degree holders can apply. Attractive salary will be paid based on the Experience. Contact +919686548709 for further details.</td>
                            <td>2018-06-21</td>
                        </tr>
                    </tbody>
                    </Table>
                </Card> */}
<p style={{textAlign:"center"}}>Currently there is no oppurtunities</p>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default Opportunities;
